export default __webpack_public_path__ + "static/clientBg-cfd9597b03b23d44f434d5839b3b1286.png";